var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _path, _g9, _g0, _path2, _g1, _g10, _path3, _g11, _path4, _g12, _g13, _path5, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSentenceLenght(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    zoomAndPan: "magnify",
    viewBox: "0 0 75 74.999997",
    height: 100,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "7adcca3606"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 70 9 L 72.5625 9 L 72.5625 66 L 70 66 Z M 70 9 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a648a9bbfa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 2.8125 9 L 5 9 L 5 66 L 2.8125 66 Z M 2.8125 9 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1d61d9ffcf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9 2.8125 L 66 2.8125 L 66 5 L 9 5 Z M 9 2.8125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cc1030b001"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9 70 L 66 70 L 66 72.5625 L 9 72.5625 Z M 9 70 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "684824b66a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 65 2.8125 L 72.5625 2.8125 L 72.5625 10 L 65 10 Z M 65 2.8125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d5d8af4324"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 2.8125 2.8125 L 10 2.8125 L 10 10 L 2.8125 10 Z M 2.8125 2.8125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "39b0b9e676"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 65 65 L 72.5625 65 L 72.5625 72.5625 L 65 72.5625 Z M 65 65 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9b54a5e472"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 2.8125 65 L 10 65 L 10 72.5625 L 2.8125 72.5625 Z M 2.8125 65 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5303f3d9e2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.851562 10 L 7 10 L 7 65 L 4.851562 65 Z M 4.851562 10 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b888d0bc5c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 10 4.875 L 64 4.875 L 64 7 L 10 7 Z M 10 4.875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "863657298b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 63 4.875 L 70 4.875 L 70 11 L 63 11 Z M 63 4.875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "787accba60"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.851562 4.875 L 11 4.875 L 11 11 L 4.851562 11 Z M 4.851562 4.875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8656353a91"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.851562 64 L 11 64 L 11 70 L 4.851562 70 Z M 4.851562 64 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "03c66892f0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 11.515625 32 L 14 32 L 14 44.710938 L 11.515625 44.710938 Z M 11.515625 32 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4e53d803c5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 61 32 L 63.265625 32 L 63.265625 44.710938 L 61 44.710938 Z M 61 32 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c2b786b74b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 11.417969 34 L 14 34 L 14 46.058594 L 11.417969 46.058594 Z M 11.417969 34 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1e4242eeb8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 61 33.308594 L 63.167969 33.308594 L 63.167969 46 L 61 46 Z M 61 33.308594 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7adcca3606)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0087ff",
    d: "M 70.113281 9.167969 L 72.1875 9.167969 L 72.1875 65.832031 L 70.113281 65.832031 Z M 70.113281 9.167969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a648a9bbfa)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0087ff",
    d: "M 2.8125 9.167969 L 4.886719 9.167969 L 4.886719 65.832031 L 2.8125 65.832031 Z M 2.8125 9.167969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1d61d9ffcf)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0087ff",
    d: "M 9.167969 2.8125 L 65.832031 2.8125 L 65.832031 4.886719 L 9.167969 4.886719 Z M 9.167969 2.8125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cc1030b001)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0087ff",
    d: "M 9.167969 70.113281 L 65.832031 70.113281 L 65.832031 72.1875 L 9.167969 72.1875 Z M 9.167969 70.113281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#684824b66a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0087ff",
    d: "M 70.113281 4.886719 L 70.113281 9.167969 L 72.1875 9.167969 L 72.1875 2.8125 L 65.832031 2.8125 L 65.832031 4.886719 Z M 70.113281 4.886719 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d5d8af4324)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0087ff",
    d: "M 4.886719 4.886719 L 9.167969 4.886719 L 9.167969 2.8125 L 2.8125 2.8125 L 2.8125 9.167969 L 4.886719 9.167969 Z M 4.886719 4.886719 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#39b0b9e676)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0087ff",
    d: "M 70.113281 70.113281 L 65.832031 70.113281 L 65.832031 72.1875 L 72.1875 72.1875 L 72.1875 65.832031 L 70.113281 65.832031 Z M 70.113281 70.113281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9b54a5e472)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0087ff",
    d: "M 4.886719 70.113281 L 4.886719 65.832031 L 2.8125 65.832031 L 2.8125 72.1875 L 9.167969 72.1875 L 9.167969 70.113281 Z M 4.886719 70.113281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0087ff",
    d: "M 68.003906 10.839844 L 69.949219 10.839844 L 69.949219 64.007812 L 68.003906 64.007812 Z M 68.003906 10.839844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5303f3d9e2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0087ff",
    d: "M 4.851562 10.839844 L 6.796875 10.839844 L 6.796875 64.007812 L 4.851562 64.007812 Z M 4.851562 10.839844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b888d0bc5c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0087ff",
    d: "M 10.816406 4.875 L 63.984375 4.875 L 63.984375 6.820312 L 10.816406 6.820312 Z M 10.816406 4.875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0087ff",
    d: "M 10.816406 68.027344 L 63.984375 68.027344 L 63.984375 69.972656 L 10.816406 69.972656 Z M 10.816406 68.027344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#863657298b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0087ff",
    d: "M 68.003906 6.820312 L 68.003906 10.839844 L 69.949219 10.839844 L 69.949219 4.875 L 63.984375 4.875 L 63.984375 6.820312 Z M 68.003906 6.820312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#787accba60)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0087ff",
    d: "M 6.796875 6.820312 L 10.816406 6.820312 L 10.816406 4.875 L 4.851562 4.875 L 4.851562 10.839844 L 6.796875 10.839844 Z M 6.796875 6.820312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0087ff",
    d: "M 68.003906 68.027344 L 63.984375 68.027344 L 63.984375 69.972656 L 69.949219 69.972656 L 69.949219 64.007812 L 68.003906 64.007812 Z M 68.003906 68.027344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8656353a91)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0087ff",
    d: "M 6.796875 68.027344 L 6.796875 64.007812 L 4.851562 64.007812 L 4.851562 69.972656 L 10.816406 69.972656 L 10.816406 68.027344 Z M 6.796875 68.027344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#0087ff",
    d: "M 62.222656 38.980469 C 55.839844 38.78125 49.449219 38.753906 43.0625 38.734375 C 36.710938 38.714844 30.355469 38.695312 24 38.675781 C 22.207031 38.667969 20.414062 38.65625 18.625 38.65625 C 17.746094 38.65625 16.863281 38.660156 15.984375 38.660156 C 15.070312 38.664062 14.15625 38.640625 13.246094 38.695312 C 12.738281 38.722656 12.242188 39.125 12.265625 39.675781 C 12.289062 40.230469 12.699219 40.621094 13.246094 40.65625 C 14.835938 40.75 16.445312 40.691406 18.035156 40.691406 C 19.632812 40.695312 21.230469 40.683594 22.828125 40.679688 C 26.019531 40.671875 29.214844 40.660156 32.40625 40.648438 C 38.761719 40.628906 45.117188 40.613281 51.46875 40.554688 C 53.261719 40.539062 55.054688 40.523438 56.847656 40.507812 C 58.640625 40.488281 60.429688 40.425781 62.222656 40.371094 C 63.117188 40.34375 63.121094 39.007812 62.222656 38.980469 Z M 62.222656 38.980469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#03c66892f0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0087ff",
    d: "M 13.890625 43.855469 C 13.984375 41.210938 13.882812 38.558594 13.863281 35.910156 C 13.859375 35.519531 13.859375 35.125 13.859375 34.734375 C 13.855469 34.441406 13.847656 34.175781 13.804688 33.886719 C 13.761719 33.605469 13.632812 33.363281 13.511719 33.109375 C 13.386719 32.84375 13.054688 32.6875 12.773438 32.6875 C 12.5 32.6875 12.148438 32.84375 12.035156 33.109375 C 12 33.191406 11.96875 33.269531 11.933594 33.347656 C 11.894531 33.441406 11.847656 33.539062 11.8125 33.636719 C 11.765625 33.757812 11.761719 33.890625 11.746094 34.019531 C 11.726562 34.214844 11.730469 34.398438 11.738281 34.59375 C 11.757812 34.945312 11.773438 35.296875 11.792969 35.652344 C 11.824219 36.304688 11.859375 36.957031 11.898438 37.613281 C 11.96875 38.871094 12.042969 40.128906 12.109375 41.386719 C 12.152344 42.210938 12.203125 43.03125 12.269531 43.855469 C 12.304688 44.273438 12.617188 44.683594 13.078125 44.664062 C 13.53125 44.644531 13.875 44.308594 13.890625 43.855469 Z M 13.890625 43.855469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4e53d803c5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0087ff",
    d: "M 63.054688 43.503906 C 63.085938 43.160156 63.125 42.8125 63.148438 42.46875 C 63.171875 42.128906 63.167969 41.78125 63.175781 41.4375 C 63.191406 40.75 63.210938 40.058594 63.226562 39.371094 C 63.261719 38.007812 63.253906 36.636719 63.261719 35.273438 C 63.265625 34.886719 63.265625 34.503906 63.257812 34.121094 C 63.25 33.863281 63.230469 33.59375 63.164062 33.347656 C 63.105469 33.121094 62.976562 32.894531 62.882812 32.675781 C 62.667969 32.179688 61.796875 32.183594 61.582031 32.675781 C 61.527344 32.804688 61.46875 32.933594 61.414062 33.0625 C 61.289062 33.355469 61.222656 33.648438 61.210938 33.964844 C 61.199219 34.308594 61.191406 34.652344 61.195312 35 C 61.195312 35.6875 61.199219 36.375 61.203125 37.0625 C 61.207031 38.429688 61.222656 39.796875 61.253906 41.164062 C 61.261719 41.546875 61.269531 41.933594 61.277344 42.316406 C 61.289062 42.710938 61.339844 43.109375 61.375 43.5 C 61.394531 43.726562 61.457031 43.925781 61.621094 44.09375 C 61.765625 44.238281 62.003906 44.347656 62.210938 44.339844 C 62.703125 44.320312 63.007812 43.972656 63.054688 43.503906 Z M 63.054688 43.503906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#0087ff",
    d: "M 62.125 40.332031 C 55.742188 40.128906 49.351562 40.105469 42.964844 40.085938 C 36.609375 40.0625 30.257812 40.042969 23.902344 40.023438 C 22.109375 40.019531 20.316406 40.007812 18.527344 40.007812 C 17.644531 40.007812 16.765625 40.011719 15.886719 40.011719 C 14.972656 40.011719 14.058594 39.992188 13.148438 40.042969 C 12.636719 40.074219 12.144531 40.472656 12.167969 41.023438 C 12.191406 41.582031 12.597656 41.972656 13.148438 42.003906 C 14.738281 42.097656 16.347656 42.039062 17.9375 42.042969 C 19.535156 42.046875 21.132812 42.035156 22.726562 42.03125 C 25.921875 42.019531 29.113281 42.007812 32.308594 42 C 38.664062 41.980469 45.015625 41.960938 51.371094 41.90625 C 53.164062 41.890625 54.957031 41.871094 56.746094 41.855469 C 58.542969 41.839844 60.332031 41.777344 62.125 41.71875 C 63.019531 41.691406 63.019531 40.359375 62.125 40.332031 Z M 62.125 40.332031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c2b786b74b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0087ff",
    d: "M 13.789062 45.203125 C 13.886719 42.558594 13.785156 39.90625 13.765625 37.261719 C 13.761719 36.867188 13.761719 36.476562 13.757812 36.082031 C 13.757812 35.792969 13.746094 35.523438 13.707031 35.234375 C 13.664062 34.957031 13.535156 34.710938 13.414062 34.460938 C 13.285156 34.195312 12.957031 34.035156 12.675781 34.035156 C 12.402344 34.035156 12.046875 34.195312 11.933594 34.460938 C 11.902344 34.539062 11.867188 34.617188 11.835938 34.699219 C 11.792969 34.792969 11.746094 34.886719 11.710938 34.984375 C 11.667969 35.109375 11.664062 35.242188 11.648438 35.371094 C 11.628906 35.566406 11.632812 35.75 11.640625 35.945312 C 11.65625 36.296875 11.675781 36.648438 11.691406 37 C 11.726562 37.65625 11.761719 38.308594 11.800781 38.960938 C 11.871094 40.21875 11.941406 41.476562 12.007812 42.734375 C 12.054688 43.558594 12.105469 44.382812 12.171875 45.203125 C 12.207031 45.625 12.519531 46.035156 12.980469 46.011719 C 13.433594 45.992188 13.773438 45.660156 13.789062 45.203125 Z M 13.789062 45.203125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1e4242eeb8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0087ff",
    d: "M 62.953125 44.851562 C 62.984375 44.507812 63.027344 44.164062 63.050781 43.820312 C 63.074219 43.476562 63.070312 43.128906 63.078125 42.785156 C 63.09375 42.097656 63.113281 41.410156 63.128906 40.722656 C 63.164062 39.355469 63.152344 37.988281 63.164062 36.621094 C 63.167969 36.238281 63.167969 35.855469 63.15625 35.46875 C 63.152344 35.214844 63.132812 34.945312 63.066406 34.695312 C 63.003906 34.46875 62.878906 34.242188 62.785156 34.027344 C 62.570312 33.53125 61.699219 33.535156 61.484375 34.027344 C 61.429688 34.15625 61.371094 34.285156 61.316406 34.414062 C 61.191406 34.703125 61.125 34.996094 61.113281 35.316406 C 61.097656 35.660156 61.09375 36.003906 61.09375 36.347656 C 61.097656 37.035156 61.101562 37.726562 61.105469 38.414062 C 61.109375 39.78125 61.125 41.148438 61.15625 42.515625 C 61.164062 42.898438 61.171875 43.285156 61.179688 43.667969 C 61.1875 44.0625 61.242188 44.457031 61.277344 44.851562 C 61.296875 45.078125 61.355469 45.277344 61.523438 45.441406 C 61.667969 45.589844 61.90625 45.699219 62.113281 45.6875 C 62.605469 45.667969 62.910156 45.320312 62.953125 44.851562 Z M 62.953125 44.851562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentenceLenght);
export default __webpack_public_path__ + "static/media/sentence_lenght.b71f138ed75de79f42fae1c591da2235.svg";
export { ForwardRef as ReactComponent };